<div class="flex min-h-screen flex-col p-2 md:p-6" cdkScrollable>
  <csl-header class="cls-header relative block shrink-0" />

  <main class="cls-main flex shrink-0 flex-col">
    <router-outlet />
  </main>

  <csl-footer class="shrink-0" />
</div>
